var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.path=== '/addresses')?_c('header',{staticClass:"addresses-header layout-header"},[_c('van-icon',{attrs:{"name":"arrow-left"},on:{"click":function($event){return _vm.$router.go(-1)}}}),_c('b',[_vm._v("お届け先管理")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }